import { render, staticRenderFns } from "./PerfumeFullView.vue?vue&type=template&id=429ebf05&scoped=true&"
import script from "./PerfumeFullView.vue?vue&type=script&lang=js&"
export * from "./PerfumeFullView.vue?vue&type=script&lang=js&"
import style0 from "./PerfumeFullView.vue?vue&type=style&index=0&id=429ebf05&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429ebf05",
  null
  
)

export default component.exports